import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { getImage } from '../../utils';
import './styles.scss';
import EditIcon from '../../assets/icons/edit.svg';
import WarningIcon from '../../assets/icons/Warning.svg';

type Props = {
  title: string;
  isOpen?: boolean;
  onClose: Function;
  showBorders?: string;
  source?: string;
  handleClick?: Function;
  onFocusFieldChange?: (val: string) => void;
  style?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
};
type State = {
  focusField: boolean;
  latestQueueName: string;
};

export default class Modal extends Component<Props, State> {
  parentEl: Element;
  private focusingRef: React.RefObject<HTMLInputElement>;

  constructor(props: Props) {
    super(props);
    this.focusingRef = React.createRef();
    this.state = this.setInitialState();

    const el = document.getElementById('modal-root');
    if (el) {
      this.parentEl = el;
    } else {
      let div = document.createElement('div');
      div.setAttribute('id', 'modal-root');
      document.body.append(div);
      this.parentEl = div;
    }
    this.focusField = this.focusField.bind(this);
  }
  setInitialState() {
    return { focusField: false, latestQueueName: '' };
  }
  focusField() {
    this.setState(
      {
        focusField: !this.state.focusField,
        latestQueueName: this.props.title,
      },
      () => this.focusingRef.current && this.focusingRef.current.focus()
    );
  }
  componentDidMount() {
    if (this.props.source) {
      localStorage.setItem('latestQueueNameEdited', this.props.title);
      localStorage.setItem('prevQueueName', this.props.title);
    }
    this.setState({
      latestQueueName: this.props.title,
    });
  }
  componentDidUpdate(_: Props, prevState: State) {
    if (this.state.latestQueueName !== prevState.latestQueueName) {
      if (this.props.onFocusFieldChange) {
        this.props.onFocusFieldChange(this.state.latestQueueName);
      }
    }
  }
  render() {
    return (
      <>
        {ReactDOM.createPortal(
          this.props.isOpen ? (
            <>
              <div className='sf-modal' style={this.props.style}>
                <div
                  style={this.props.innerStyle}
                  id='modal'
                  className={`${
                    this.props.title === 'Delete queue'
                      ? 'modal-width'
                      : this.props.source === 'queue-creation'
                      ? 'queue-creation'
                      : ''
                  }`}>
                  <img
                    id='modal-close'
                    className='clickable'
                    src={getImage('close-dark.svg')}
                    alt='close'
                    onClick={() => {
                      this.props.onClose();
                    }}
                  />
                  <div
                    id='modal-title'
                    style={this.props.title === 'Network' ? { display: 'none' } : {}}>
                    <div id='title'>
                      {this.state.focusField ? (
                        <input
                          type='text'
                          ref={this.focusingRef}
                          value={this.props.title}
                          className='input-style'
                          onChange={(event) => {
                            this.setState(
                              {
                                latestQueueName: event.target.value,
                              },
                              () => {
                                let prevQueueName = localStorage.getItem(
                                  'latestQueueNameEdited'
                                );
                                setTimeout(() => {
                                  localStorage.setItem(
                                    'prevQueueName',
                                    prevQueueName ? prevQueueName : ''
                                  );
                                }, 1000);
                                localStorage.setItem(
                                  'latestQueueNameEdited',
                                  this.state.latestQueueName
                                );
                              }
                            );
                          }}
                          style={{
                            width: this.state.latestQueueName.length + 1 + 'ch',
                            fontFamily: 'Open Sans',
                          }}
                        />
                      ) : this.props.source === 'general-tab' ? (
                        <div style={{ display: 'flex' }}>
                          <img src={WarningIcon} alt='warning-img' />
                          <div style={{ marginLeft: '10px' }}>{this.props.title}</div>
                        </div>
                      ) : (
                        <div
                          style={
                            this.props.title === 'Chat details'
                              ? { fontWeight: 600, letterSpacing: '-0.3px' }
                              : {}
                          }>
                          {this.props.title}
                        </div>
                      )}
                    </div>
                    {this.props.source === 'queue-creation' &&
                      this.state.focusField === false &&
                      this.props.title !== 'Default' && (
                        <img
                          src={EditIcon}
                          alt='queue-name'
                          onClick={() => {
                            this.focusField();
                            this.props.handleClick &&
                              this.props.handleClick(this.props.title);
                          }}
                        />
                      )}
                  </div>
                  {this.props.children}
                </div>
              </div>
            </>
          ) : null,
          this.parentEl
        )}
      </>
    );
  }
}
